// import "./App.css";
import { useEffect } from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import ReactGA from "react-ga4";

import Navbar from "./components/utils/Navbar";
import HomeNavbar from "./components/utils/HomeNavbar";

import MainDashboard from "./components/dashboards/MainDashboard";
import AdminDashboard from "./components/dashboards/AdminDashboard";

import SignUp from "./components/auth/SignUp";
import SignIn from "./components/auth/SignIn";
import AccountConfirmation from "./components/auth/AccountConfirmation";
import ForgotPassword from "./components/auth/ForgotPassword";
import PasswordReset from "./components/auth/PasswordReset";
import AccountVerification from "./components/auth/AccountVerification";
import SendConfirmationEmail from "./components/auth/SendConfirmationEmail";

import { HomePage } from "./components/home/Home";
import Contact from "./components/home/Contact";
import { MissionStatement } from "./components/home/MissionStatement";
import { NewslettersSubscription } from "./components/home/Newsletters";

import IngredientForm from "./components/ingredients/IngredientForm";
import { GOOGLE_ANALYTICS_TRACKING_ID } from "./config/environment";

import { useAnalyticsEventTracker } from "./components/utils/useAnalyticsEventTracker";

/**
 * This component renders all of the application code
 *  
 * @returns {JSX.Element} Application
 */
function App() {
  ReactGA.initialize(GOOGLE_ANALYTICS_TRACKING_ID);
  const eventTracker = useAnalyticsEventTracker(true);

  useEffect(() => {
    eventTracker({
      hitType: "pageview",
      page: window.location.pathname + window.location.search,
    });
  }, []);

  return (
    <>
      <Router>
        <Routes>
          <Route
            path="/admin-dashboard"
            exact
            element={
              <>
                <Navbar />
                <AdminDashboard />
              </>
            }
          />
          <Route
            path="/dashboard"
            exact
            element={
              <>
                <Navbar />
                <MainDashboard />
              </>
            }
          />
          <Route
            path="/ingredients/new"
            exact
            element={
              <>
                <Navbar />
                <IngredientForm />
              </>
            }
          />
          <Route
            path="/ingredients/:id/edit"
            exact
            element={
              <>
                <Navbar />
                <IngredientForm />
              </>
            }
          />

          <Route
            path="/"
            exact
            element={
              <>
                <HomeNavbar />
                <HomePage />
              </>
            }
          />
          <Route
            path="/mission"
            exact
            element={
              <>
                <HomeNavbar />
                <MissionStatement />
              </>
            }
          />
          <Route
            path="/newsletters-subscribe"
            exact
            element={
              <>
                <HomeNavbar />
                <NewslettersSubscription />
              </>
            }
          />
          <Route
            path="/contact"
            exact
            element={
              <>
                <HomeNavbar />
                <Contact />
              </>
            }
          />
          <Route
            path="/signup"
            exact
            element={
              <>
                <HomeNavbar />
                <SignUp />
              </>
            }
          />
          <Route
            path="/signin"
            exact
            element={
              <>
                <HomeNavbar />
                <SignIn />
              </>
            }
          />
          <Route
            path="/account-confirm"
            exact
            element={
              <>
                <HomeNavbar />
                <AccountConfirmation />
              </>
            }
          />
          <Route
            path="/forgot-password"
            exact
            element={
              <>
                <HomeNavbar />
                <ForgotPassword />
              </>
            }
          />
          <Route
            path="/reset-password/:token"
            exact
            element={
              <>
                <HomeNavbar />
                <PasswordReset />
              </>
            }
          />
          <Route
            path="/verify-account/:token"
            exact
            element={
              <>
                <HomeNavbar />
                <AccountVerification />
              </>
            }
          />
          <Route
            path="/send-confirmation-email"
            exact
            element={
              <>
                <HomeNavbar />
                <SendConfirmationEmail />
              </>
            }
          />
        </Routes>
      </Router>
    </>
  );
}

export default App;
